import fetch from '@/utils/fetch';

const model = {
  state: {
    tableLoading: false,
    shopTableLoading: false,
    advanceList: [],
    advanceShopList: [],
    advanceShopParams: {
      pageNo: 1,
      pageSize: 10,
    },
    advanceShopTotal: 0,
    currentAdvanceDate: '',
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { advance }, getState }) => ({
    async getAdvanceList() {
      advance.setState({ tableLoading: true });

      const data = await fetch('/saasmerchant/web/advance/advance', { type: 'POST' });
      if (data) {
        advance.setState({ advanceList: data });
      }
      advance.setState({ tableLoading: false });
    },
    setAdvanceDate(params) {
      advance.setState({ currentAdvanceDate: params });
    },
    async getAdvanceShopList() {
      advance.setState({ shopTableLoading: true });
      const { advanceShopParams, currentAdvanceDate } = getState().advance;
      const params = {
        ...advanceShopParams,
        advanceDate: currentAdvanceDate,
      };
      const data = await fetch('/saasmerchant/web/advance/advanceForShop', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        advance.setState({ advanceShopList: data.list, advanceShopTotal: data.total });
      }

      advance.setState({ shopTableLoading: false });
    },
    handlePage(pageNo, pageSize) {
      advance.setState({ advanceShopParams: { pageNo, pageSize } });
    },
  }),
};

export default model;
